import React from 'react'

const Temp = () => {
  return (
    <div>Temp Page</div>
  )
}

export default Temp